import { STATUS_LABELS, STATUS_STYLES } from "../lib/api";

export const StatusBadge = ({ status, className = "" }) => {
  const label = STATUS_LABELS[status] || status;
  const style = STATUS_STYLES[status] || "bg-zinc-100 text-zinc-700 border-zinc-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold border ${style} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotColor(status)}`} />
      {label}
    </span>
  );
};

function dotColor(s) {
  return {
    awaiting_arrival: "bg-zinc-400",
    received: "bg-blue-500",
    awaiting_collection: "bg-yellow-500",
    collected: "bg-orange-500",
    in_specification: "bg-violet-500",
    ready_for_return: "bg-fuchsia-500",
    returned: "bg-red-500",
    ready_for_dispatch: "bg-lime-500",
    dispatched: "bg-emerald-500",
    delivered: "bg-emerald-200",
    issue: "bg-rose-600",
  }[s] || "bg-zinc-400";
}
